export default __webpack_public_path__ + "static/overview-20d638b26fd035e33ff2430d96a258fb.mp4";